import { createFileRoute } from '@tanstack/react-router'
import { Trans } from '@lingui/react/macro'
import { AccountLockedHeader } from '@/features/account-locked/account-locked-header'
import { AccountLockedLinks } from '@/features/account-locked/account-locked-links'
import { getBrandConfig } from '@/config/config'

export const Route = createFileRoute('/_app/account-locked/under-age')({
  component: RouteComponent,
})

function RouteComponent() {
  const { ageRestriction } = getBrandConfig()

  return (
    <>
      <AccountLockedHeader
        heading={<Trans>Access restricted</Trans>}
        description={
          <p>
            <Trans>
              You must be {ageRestriction} years or older to play. If you
              believe you should have access, please provide valid proof of
              identity confirming your age using our Account Verification tools.
            </Trans>
          </p>
        }
      />
      <AccountLockedLinks accountVerification />
    </>
  )
}
